import { Chip } from '@c2fo/liquidity';
import { CloudUploadIcon, DownloadIcon } from '@c2fo/liquidity/icons';
import { CredentialType as CredentialTypeEnum } from '../../api/shared';

const getCredentialTypeLabel = (type: CredentialTypeEnum): string => {
  switch (type) {
    case CredentialTypeEnum.CREDENTIAL_TYPE_SSH:
      return 'SFTP';
    case CredentialTypeEnum.CREDENTIAL_TYPE_AWS:
      return 'AWS S3';
    case CredentialTypeEnum.CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT:
      return 'GCP Storage';
    case CredentialTypeEnum.CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL:
      return 'Azure Blob';
    default:
      return 'Unknown';
  }
};

const getCredentialTypeChipType = (type: CredentialTypeEnum): 'primary' | 'secondary' | 'warning' => {
  switch (type) {
    case CredentialTypeEnum.CREDENTIAL_TYPE_AWS:
    case CredentialTypeEnum.CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT:
    case CredentialTypeEnum.CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL:
      return 'primary';
    case CredentialTypeEnum.CREDENTIAL_TYPE_SSH:
      return 'secondary';
    default:
      return 'warning';
  }
};

const isCloudCredential = (type: CredentialTypeEnum): boolean => {
  return [
    CredentialTypeEnum.CREDENTIAL_TYPE_AWS,
    CredentialTypeEnum.CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT,
    CredentialTypeEnum.CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL,
  ].includes(type);
};

const isFileTransferCredential = (type: CredentialTypeEnum): boolean => {
  return type === CredentialTypeEnum.CREDENTIAL_TYPE_SSH;
};

export const CredentialTypeChip: React.FC<{ credentialType: CredentialTypeEnum }> = ({ credentialType }) => {
  const label = getCredentialTypeLabel(credentialType);
  const Icon = isFileTransferCredential(credentialType)
    ? DownloadIcon
    : isCloudCredential(credentialType)
      ? CloudUploadIcon
      : null;

  return (
    <Chip
      label={
        <span className="inline-flex items-center gap-1">
          {Icon && <Icon className="h-3 w-3" />}
          {label}
        </span>
      }
      type={getCredentialTypeChipType(credentialType)}
      variant="outlined"
      size="xs"
    />
  );
};
